import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  awaitContent$default12h4qgz8umrzx as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_awaitContent__vf28kb($this, min, $completion) {
  if ($this.w4i().v2() >= fromInt(min)) {
    return true;
  }
  var tmp = $this.n4k_1.e4j(min, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    transferFromDelegate($this);
    return true;
  }
  return false;
}
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.o4k_1.w4f($this.n4k_1.w4i());
  $this.p4k_1 = add($this.p4k_1, appended);
}
function updateConsumed($this) {
  $this.q4k_1 = add($this.q4k_1, subtract($this.p4k_1, $this.o4k_1.v2()));
  $this.p4k_1 = $this.o4k_1.v2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.n4k_1 = delegate;
        this.o4k_1 = new (Buffer())();
        this.p4k_1 = 0n;
        this.q4k_1 = 0n;
      }
      r4k() {
        updateConsumed(this);
        return this.q4k_1;
      }
      b4j() {
        return this.n4k_1.b4j();
      }
      d4j() {
        return this.o4k_1.o3x() && this.n4k_1.d4j();
      }
      w4i() {
        transferFromDelegate(this);
        return this.o4k_1;
      }
      e4j(min, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitContent__vf28kb.bind(VOID, this, min), $completion);
      }
      h4j(cause) {
        this.n4k_1.h4j(cause);
        this.o4k_1.q6();
      }
    }
    protoOf($).f4j = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
